import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgNextAlt = function SvgNextAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#next-alt_svg__clip0)"
  }, React.createElement("path", {
    d: "M12.51 0c-6.609 0-12 5.344-12 11.953 0 6.61 5.391 12 12 12 6.61 0 12-5.39 12-12S19.12 0 12.51 0zm0 21.984c-5.53 0-9.984-4.5-9.984-9.984 0-5.531 4.5-9.984 9.985-9.984 5.531 0 9.984 4.5 9.984 9.984s-4.453 9.984-9.984 9.984z"
  }), React.createElement("path", {
    d: "M15.23 7.266a1.02 1.02 0 00-1.407 0 1.02 1.02 0 000 1.406l2.297 2.297H6.558a.99.99 0 00-.985.984c0 .516.469.985.985.985h9.562l-2.297 2.296a1.02 1.02 0 000 1.407c.188.187.469.28.703.28.235 0 .516-.093.704-.28l3.984-3.985a1.02 1.02 0 000-1.406L15.23 7.266z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "next-alt_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z",
    transform: "translate(.51)"
  }))));
};

export default SvgNextAlt;